import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { HotelSearchState, HotelSearchParams, HotelSearchResponse } from '@/types/hotel-search';

const initialState: HotelSearchState = {
  results: [],
  loading: false,
  error: null,
  searchParams: {},
  totalCount: 0,
  currentPage: 1,
  pageSize: 20,
};

export const searchHotels = createAsyncThunk(
  'hotelSearch/search',
  async (params: HotelSearchParams) => {
    // TODO: Replace with actual API call
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/Hotels/search`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    });
    
    if (!response.ok) {
      throw new Error('Failed to search hotels');
    }
    
    return response.json() as Promise<HotelSearchResponse>;
  }
);

const hotelSearchSlice = createSlice({
  name: 'hotelSearch',
  initialState,
  reducers: {
    setSearchParams: (state, action: PayloadAction<HotelSearchParams>) => {
      state.searchParams = { ...state.searchParams, ...action.payload };
    },
    clearResults: (state) => {
      state.results = [];
      state.totalCount = 0;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchHotels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchHotels.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload.hotels;
        state.totalCount = action.payload.totalCount;
        state.currentPage = action.payload.page;
        state.pageSize = action.payload.pageSize;
      })
      .addCase(searchHotels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to search hotels';
      });
  },
});

export const { setSearchParams, clearResults, setPage } = hotelSearchSlice.actions;
export default hotelSearchSlice.reducer;
